import { Scope } from '../enum/scope'
import { rememberPayload, wireEntity } from '../../_utils/fcdc-v2'

export class JwtRole {
  flg: Scope[]
  sub?: string
  private unknownScopeBits = 0

  constructor(json: any) {
    this.flg = this.decodeScopes(json.flg)
    this.sub = json.sub
    rememberPayload(this, json)
  }

  toJSON(): Record<string, unknown> {
    const json = wireEntity(this) as Record<string, unknown>
    delete json['unknownScopeBits']
    json['flg'] = this.serializeScopes()
    return json
  }

  combineScopes(...scopes: Scope[]): number {
    return scopes.reduce((acc, scope) => acc | scope, 0)
  }

  decodeScopes(value: number): Scope[] {
    if (typeof value !== 'number') {
      return []
    }
    const scopes: Scope[] = []
    let knownMask = 0
    for (const scopeKey in Scope) {
      if (!isNaN(Number(scopeKey))) continue
      const scope = Scope[scopeKey as keyof typeof Scope]
      knownMask |= scope
      if (value & scope) {
        scopes.push(scope)
      }
    }
    this.unknownScopeBits = value & ~knownMask
    return scopes
  }

  serializeScopes(): number {
    return this.combineScopes(...this.flg) | this.unknownScopeBits
  }
}
